import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EstoqueService } from 'src/app/services/EstoqueService/estoque.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

@Component({
  selector: 'app-cadastro-ajuste-estoque',
  templateUrl: './cadastro-ajuste-estoque.component.html',
  styleUrls: ['./cadastro-ajuste-estoque.component.scss']
})
export class CadastroAjusteEstoqueComponent implements OnInit {
  form: FormGroup;
  isLoading = false;
  produtoNome = '';
  quantidadeAtual = 0;
  pkMovimentacao = 0;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private estoqueService: EstoqueService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.fb.group({
      QT_MOVM_NOVA: [null, [Validators.required, Validators.min(1)]],
      TX_MOTV: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.pkMovimentacao = Number(params['PK_MOVM_ESTQ'] ?? 0);
      this.produtoNome = params['NM_PROD'] ?? '';
      this.quantidadeAtual = Number(params['QT_MOVM'] ?? 0);
      if (!this.pkMovimentacao) {
        this.swalAlert.showAlert('Atenção!', 'Movimentação não informada.', 'warning', true, false, undefined, () =>
          this.router.navigate(['listagem/estoque/relatorio-estoque'], {
            queryParams: { report: 'movimentacoes' }
          })
        );
      }
    });
  }

  postarDados(): void {
    if (!this.form.valid || !this.pkMovimentacao) {
      this.swalAlert.showAlert('Atenção!', 'Preencha todos os campos.', 'warning');
      return;
    }

    const funcionarioId = Number(localStorage.getItem('id') ?? 0);
    if (!funcionarioId) {
      this.swalAlert.showAlert('Atenção!', 'Usuário não identificado.', 'warning');
      return;
    }

    this.isLoading = true;
    this.estoqueService
      .CreateAjusteMovimentacao({
        PK_MOVM_ESTQ: this.pkMovimentacao,
        QT_MOVM_NOVA: Number(this.form.controls['QT_MOVM_NOVA'].value),
        TX_MOTV: String(this.form.controls['TX_MOTV'].value).trim(),
        FK_FUNC_OPER: funcionarioId
      })
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['listagem/estoque/relatorio-estoque'], {
            queryParams: { report: 'movimentacoes' }
          });
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }
}
